/**
 * Product tag representation of its keys, and an optional defaultValue
 * @typedef {object} PRODUCT_TAGS
 * @property {string} key - the string that represents the tag in the product tags string
 * @property {number} [defaultValue] - do not change these values, there exists side effects by changing it
 */
export const PRODUCT_TAGS = {
  NO_SHOW: {
    key: 'noshow:',
  },
  INCREASE_AMOUNT: {
    key: 'quantidade_aumento:',
    defaultValue: 1,
  },
  MINIMUM_PURCHASE_AMOUNT: {
    key: 'Pedido mínimo (produto)_',
    defaultValue: 1,
  },
};

export const DEFAULT_TOAST_PARAMS = {
  duration: 3000,
  isClosable: true,
};

export const PRODUCT_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
};

export const INVENTA_SHOP_PRODUCT_URL = 'https://inventa.shop/products/';

export const SALES_FORMAT_OPTIONS = {
  UNIT: 'unit',
  BOX: 'box',
};

export const INVENTORY_POLICY = {
  CONTINUE: 'continue',
  DENY: 'deny',
};
